import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IndexPath } from '@/Config/app/router/index.path';
import { ConversationRatingGraphic } from '@/Domain/components/Widget/ConversationRating/ConversationRating.graphic';

export const ConversationRatingProtected = () => {
  const { t } = useTranslation('insights_page');

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-3"
      data-testid="conversation-rating-protected"
    >
      <ConversationRatingGraphic />
      <p className="font-medium">{t('conversation_rating_protected.title')}</p>
      <p className="text-sm text-foreground-subtle text-center">
        <Trans
          i18nKey="insights_page:conversation_rating_protected.description"
          components={{
            setting_link: (
              <Link to={`../${IndexPath.subscription}`} className="text-foreground font-medium" />
            ),
          }}
        />
      </p>
    </div>
  );
};
